import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type JointBookDb = {
  bookId: string;
  userId: string;
  editable: boolean;
}
const initial: JointBookDb = {
  bookId: '',
  userId: '',
  editable: false
};

export type JointBookDbHashType = {
  [key in string]: JointBookDb;
}

export type JointBookAddPayload = {
  id?: string;
} & JointBookDb;
export type JointBookUpdatePayload = {
  id: string;
} & { [P in keyof JointBookDb]?: JointBookDb[P] };

export type JointBookDbState = {
  jointBooks: JointBookDbHashType;
}

export const  generateJointBookId = (): string =>  generateId('jb');
let initialState: JointBookDbState = { jointBooks: {} };
const key = 'jointBooks';

const jointBookDbSlice = createSlice({
  name: 'jointBookDb',
  initialState,
  reducers: {
    initializeJointBooks(state: JointBookDbState) {
      state.jointBooks = {};
    },
    addJointBook(state: JointBookDbState, action: PayloadAction<JointBookAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateJointBookId();
      state.jointBooks[id] = obj;
      saveData(key, id, obj);
    },
    updateJointBook(state: JointBookDbState, action: PayloadAction<JointBookUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.jointBooks[id] === undefined) {
        console.log(`*** JointBook not found: ${id}`);
      } else {
        const newData = { ...state.jointBooks[id], ...obj };
        state.jointBooks[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteJointBook(state: JointBookDbState, action: PayloadAction<JointBookUpdatePayload>) {
      const id = action.payload.id;
      delete state.jointBooks[id];
      deleteData(key, id);
    },
    saveJointBooks(state: JointBookDbState) {
      saveAllData(key, state.jointBooks);
    },
    signUpJointBooks(state: JointBookDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.jointBooks, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: JointBookDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.jointBooks = updatedValues;
      if (changed) saveAllData(key, state.jointBooks);
    })
  }
})

export const { initializeJointBooks, addJointBook, updateJointBook, deleteJointBook, saveJointBooks, signUpJointBooks } = jointBookDbSlice.actions;
export default jointBookDbSlice.reducer;
